import axiosInstance from "./axiosInstance";

// Get only groups
export const fetchGroupsApi = () =>
  axiosInstance.get("api/e-visitingcard/groups");

// Get full cards (including groups)
export const fetchAllTemplatesApi = () =>
  axiosInstance.get("api/e-visitingcard/card-templates");

// fetch templates by groupId
export const fetchTemplatesByGroupApi = (groupId) =>
  axiosInstance.get(`api/e-visitingcard/card-templates?groupId=${groupId}`);

// Fetch active languages
export const fetchLanguagesApi = () =>
  axiosInstance.get("api/e-visitingcard/card-languages");

// Fetch card label + user details based on language
export const fetchLanguageDetailsApi = (languageId) =>
  axiosInstance.get(`api/e-visitingcard/card-label-detail?languageId=${languageId}`);

export default {
  fetchGroupsApi,
  fetchAllTemplatesApi,
  fetchTemplatesByGroupApi,
  fetchLanguagesApi,
  fetchLanguageDetailsApi,
};
